var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonPress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57 63",
    style: {
      enableBackground: "new 0 0 57 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M54.9,45.7L54.9,45.7L54.9,45.7l-2-24.2c-0.1-1.2-1.2-2.3-2.5-2.3h-4.3V19c0-6.7-6.9-11.1-17.7-11.1 c-10.8,0-17.7,4.4-17.7,11.1v0.2H6.5c-1.3,0-2.4,1-2.5,2.3L2,45.6v9.8c0,1.4,1.1,2.5,2.5,2.5h48c0.7,0,1.3-0.3,1.8-0.7 c0.5-0.5,0.7-1.1,0.7-1.8L54.9,45.7z M50,52.9H7v-4.7h42.9L50,52.9z M28.4,41.8c10.8,0,17.7-4.4,17.7-11.1v-6.6H48l1.5,19H7.2 l1.5-19h1.8v6.6C10.7,37.5,17.5,41.8,28.4,41.8z M28.4,25.1c-7.6,0-12.7-2.5-12.7-6.1c0-3.7,5-6.1,12.7-6.1c7.7,0,12.7,2.4,12.7,6.1 S36.1,25.1,28.4,25.1z M41.2,30.8c0,3.7-5,6.1-12.7,6.1s-12.7-2.4-12.7-6.1v-3.7c3.2,1.9,7.5,3,12.7,3c5.2,0,9.6-1,12.7-3V30.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPress);
export default __webpack_public_path__ + "static/media/button-press.796196c6d6e2251af13aee17cf9843fb.svg";
export { ForwardRef as ReactComponent };